import type { ICallingActionPayload, ICallingActionResponse } from 'entities/AICalling/api/types'
import { AfterCallAction } from './AfterCallAction'
import { DuringCallAction } from './DuringCallAction'

export const createCallingAction = (card: ICallingActionResponse | ICallingActionPayload) => {
  switch (card.trigger_type) {
    case 'during_call':
      return new DuringCallAction(card)
    default:
      return new AfterCallAction(card)
  }
}
